import {FornecedorInfoGrid, FornecedorInformacao} from '@components/fornecedores/FornecedorInformacao.tsx';
import {ProdutosPage} from '@components/produtos/pages/ProdutosPage.tsx';
import {_fornecedor_endpoints} from '@components/fornecedores/endpoints/_fornecedor_endpoints.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {IFornecedor} from '@models/fornecedores/fornecedor.ts';
import {Grid, Paper, Tab, Tabs} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import {useEffect, useState} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router';
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface FornecedorPageProps extends DefaultPageProps {

}

type tabs = 'Informacoes' | 'Produtos'

export const FornecedorPage: React.FC<FornecedorPageProps> = (props) => {
	const {Get} = useApi();

	const [fornecedor, setFornecedor] = useState<IFornecedor | undefined>();
	const [tab, setTab] = useState<tabs>('Informacoes');
	const [searchParams] = useSearchParams();
	const [refresh, setRefresh] = useState(false);

	const [fornecedorId] = useState(searchParams.get('fornecedorId') ?? undefined);
	
	const location = useLocation();
	const navigate = useNavigate();
	
	useEffect(() => {
		if (fornecedorId || refresh) {
			Get(_fornecedor_endpoints.GetFornecedores({Ids: [Number(fornecedorId)], DeveIncluir: ['Criador']}, {
				page: 1,
				pageSize: 1,
			})).then(x => {
				if (x.hasData) {
					setFornecedor(x.items[0]);
				} else {
					setFornecedor(undefined);
				}
			}).finally(() => {
				setRefresh(false);
			});
		}
		
	}, [fornecedorId, refresh]);
	
	useEffect(() => {
		setTab(location.hash.slice(1) as tabs || 'Informacoes');
	}, [location.hash]);

	
	return (<DefaultContainer titulo={`Fornecedor ${fornecedorId} ${fornecedor?.nome}`}
	                          hideHeader={props.hideHeader}
	                          size={'large'}
	                          component={Paper}>
		{fornecedor &&
            <Grid container spacing={1.5}>
                <Grid size={12}>
                    <FornecedorInformacao variant={'list'} value={fornecedor}/>
                </Grid>
                <Grid size={12}>
                    <Tabs value={tab}
                          onChange={(_e, v) => {
						      navigate({
							      pathname: location.pathname,
							      search: location.search,
							      hash: v,
						      });
					      }}>
                        <Tab value={'Informacoes'} label={"Informações"}/>
                        <Tab value={'Produtos'} label={"Produtos"}/>
                    </Tabs>
                </Grid>
                <Grid size={12}>
					{tab === 'Informacoes' && <FornecedorInfoGrid onUpdate={() => {
						setRefresh(true);
					}} value={fornecedor}/>}
					{tab === 'Produtos' &&
                        <Grid container>
                            <Grid>
                            </Grid>
                            <Grid>

                            </Grid>
                            <Grid size={12}>
                                <ProdutosPage hideHeader filtros={{idFornecedor: [fornecedor.id]}}/>
                            </Grid>
                        </Grid>}
                </Grid>
            </Grid>}
	</DefaultContainer>);
};